import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
require("./style.css");
class Autocomplete extends Component {
  static propTypes = {
    suggestions: PropTypes.instanceOf(Array),
    name: ""
  };

  static defaultProps = {
    suggestions: [],
    name: ""
  };

  constructor(props) {
    super(props);

    this.state = {
      // The active selection's index
      activeSuggestion: 0,
      // The suggestions that match the user's input
      filteredSuggestions: [],
      // Whether or not the suggestion list is shown
      showSuggestions: false,
      // What the user has entered
      userInput: this.props.value,
      name: this.props.name,
      suggest: false,
      count: 0
    };
  }

  // Event fired when the input value is changed
  onChange = e => {
    const { suggestions, name } = this.props;
    // console.log(e.currentTarget.innerText);
    const userInput = e.currentTarget.value;
    // console.log(userInput);
    // Filter our suggestions that don't contain the user's input
    const filteredSuggestions = suggestions.filter(
      suggestion =>
        suggestion.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    if (!userInput) {
      this.setState({
        activeSuggestion: 0,
        filteredSuggestions: [],
        showSuggestions: false,
        userInput: null,
        [name]: null
      });
      this.props.nextWindow(userInput);
      return false
    }
    // Update the user input and filtered suggestions, reset the active
    // suggestion and make sure the suggestions are shown
    this.setState({
      activeSuggestion: 0,
      filteredSuggestions,
      showSuggestions: true,
      userInput: e.currentTarget.value,
      [name]: e.currentTarget.value,
    });
    this.props.nextWindow(userInput);
    // return userInput;
  };

  // Event fired when the user clicks on a suggestion
  onClick = e => {
    const { name } = this.props;
    let userInput = e.currentTarget.innerText;
    // Update the user input and reset the rest of the state
    this.setState({
      activeSuggestion: 0,
      filteredSuggestions: [],
      showSuggestions: false,
      userInput: e.currentTarget.innerText,
      [name]: e.currentTarget.innerText
    });
    this.props.nextWindow(userInput);
  };

  // Event fired when the user presses a key down
  onKeyDown = e => {
    const { activeSuggestion, filteredSuggestions } = this.state;

    // User pressed the enter key, update the input and close the
    // suggestions
    if (e.keyCode === 13) {
      this.setState({
        activeSuggestion: 0,
        showSuggestions: false,
        userInput: filteredSuggestions[activeSuggestion]
      });
    }
    // User pressed the up arrow, decrement the index
    else if (e.keyCode === 38) {
      if (activeSuggestion === 0) {
        return;
      }

      this.setState({ activeSuggestion: activeSuggestion - 1 });
    }
    // User pressed the down arrow, increment the index
    else if (e.keyCode === 40) {
      if (activeSuggestion - 1 === filteredSuggestions.length) {
        return;
      }

      this.setState({ activeSuggestion: activeSuggestion + 1 });
    }
  };
  onSuggestion = async (e) => {

    if (e == "suggest") {
      // console.count("");
      await this.setState({ suggest: true })
    }
    else {
      setTimeout(async () => {
        await this.setState({ suggest: false })
      }, 2000);
    }

  }
  render() {
    const {
      onChange,
      onClick,
      onKeyDown,
      state: {
        activeSuggestion,
        filteredSuggestions,
        showSuggestions,
        userInput,
        name, suggest
      }
    } = this;

    let suggestionsListComponent;

    if (showSuggestions && userInput) {
      if (filteredSuggestions.length) {
        suggestionsListComponent = (
          <ul class="suggestions">
            {
              filteredSuggestions.map((suggestion, index) => {
                let className;

                // Flag the active suggestion with a class
                if (index === activeSuggestion) {
                  className = "suggestion-active";
                }

                return (
                  <li className={className} key={suggestion} onClick={onClick} >
                    {suggestion}
                  </li>
                );
              })
            }
          </ul >
        );
      } else {
        suggestionsListComponent = (
          <div class="no-suggestions">
            <em>No suggestions, you're on your own!</em>
          </div>
        );
      }
    }

    return (
      <Fragment>
        <input
          type="text"
          className="form-control"
          name={name}
          onClick={() => { this.onSuggestion("suggest") }}
          onBlur={() => { this.onSuggestion("1s") }}
          onChange={onChange}
          onKeyDown={onKeyDown}
          value={userInput}
        />
        {suggest && suggestionsListComponent}
      </Fragment>
    );
  }
}

export default Autocomplete;
